const getSentryConfig = () => fetch('/api/sentry', { credentials: 'same-origin' });
export default getSentryConfig;
